/* eslint-disable react/no-unused-prop-types */
import React, { useRef } from 'react';
import { Provider } from 'react-redux';
import { makeStore, AppStore } from 'src/redux/store';
import { ForumsPageProps } from 'src/types/NextApp';
import setSSRPageData from 'src/redux/setSSRPageData';
import { useFirstRender } from 'src/utils';

const StoreProvider: React.FC<React.PropsWithChildren<ForumsPageProps>> = ({
  children,
  ...pageResponseData
}) => {
  const storeRef = useRef<AppStore>();
  const firstRender = useFirstRender();
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore();
  }

  if (pageResponseData.pageType && firstRender) {
    setSSRPageData(pageResponseData, storeRef.current.dispatch);
  }

  return (
    <Provider store={storeRef.current}>
      {children}
    </Provider>
  );
};

export default StoreProvider;
